import styled from "styled-components"

import NetworkAd from "components/network-ad"

export const NetworkAdUnit = styled(NetworkAd)`
  position: sticky;
  top: 10rem;
  left: 0;
  width: 100%;
  float: left;
  visibility: hidden;

  &:first-of-type {
    margin-top: 2rem;
  }
`
